// Which requests / equipment each role sees (same rules the pages always had)
import * as requestApi from "./api";
import * as equipmentApi from "../equipments/api";
import { engineerRowsFor } from "@/config/periferice";

export async function fetchRequestsForRole(user) {
  const role = user?.role;
  if (["admin", "dtisef", "rector"].includes(role)) {
    return requestApi.getAllRequestsTableData();
  }
  if (role === "inginer" || role === "inginer-pc") {
    // each request keeps the engineer it was filed for (Configurare decides it for new ones)
    return engineerRowsFor(role, await requestApi.getAllRequestsTableData());
  }
  // everyone else: the requests of all their departments
  return requestApi.getRequestsTableDataByUser(user.userId);
}

export async function fetchEquipmentForRole(user) {
  const role = user?.role;
  if (["admin", "inginer", "inginer-pc", "dtisef", "rector", "equipment_administrator"].includes(role)) {
    // both engineers see ALL equipment types (since 2026-11-05; inginer-pc used to get only his types).
    // Requests stay split by engineer_role (fetchRequestsForRole)
    return equipmentApi.getEquipmentsTableData();
  }
  return equipmentApi.getEquipmentsTableDataByUser(user.userId);
}

// Statuses after which nothing more happens to a request
export const CLOSED_STATUSES = ["Îndeplinit", "Respins", "Imposibil la moment", "Anulat"];
